import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import NavItem from './item'
import currentUserSelector from 'selectors/current_user'
import parametersSelector from 'selectors/parameters'

const Header = ({ user_signed_in, current_user, config_parameters }) => (
  <ul className="nav nav-tabs content-tabs">
    <NavItem to="/users/sign_in" passed={user_signed_in}>
      <span>1</span>
      <span>
        <i className="fa fa-check" />
      </span>
      {I18n.t('nav.sign_up')}
    </NavItem>
    <NavItem to="/deposits">
      <span>2</span>
      <span>
        <i className="fa fa-check" />
      </span>
      {I18n.t('nav.manage_deposits')}
    </NavItem>
    <NavItem to="/tokens">
      <span>3</span>
      <span>
        <i className="fa fa-check" />
      </span>
      {I18n.t('nav.buy_coins', { coin_name: config_parameters['coin.name'] })}
    </NavItem>
    <NavItem to="/verification" passed={current_user.kyc_verification === 'approved'}>
      <span>4</span>
      <span>
        <i className="fa fa-check" />
      </span>
      {I18n.t('nav.verification')}
    </NavItem>
    <NavItem to="/" exact>
      <span>5</span>
      <span>
        <i className="fa fa-check" />
      </span>
      {I18n.t('nav.dashboard')}
    </NavItem>
  </ul>
)

const mapStateToProps = state => ({
  user_signed_in: !!state.users.authorization,
  current_user: currentUserSelector(state),
  config_parameters: parametersSelector(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/containers/layouts/default/nav/index.js